<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';
defineOptions({ inheritAttrs: false });
const props = defineProps<{
  modelValue?: string | number | null | (string | number)[];
  multiple?: boolean;
  class?: HTMLAttributes['class'];
}>();
const emit = defineEmits<{ 'update:modelValue': [value: any] }>();
const model = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});
</script>

<template>
  <select
    v-bind="$attrs"
    v-model="model"
    :multiple="multiple"
    :class="cn('ui-select', props.class)"
  >
    <slot />
  </select>
</template>
